import { CLIENTS } from "../../lib/content";

export const ClientMarquee = ({ speed = "48s" }) => {
  const items = [...CLIENTS, ...CLIENTS];
  return (
    <div className="relative overflow-hidden py-10 border-y border-slate-200 marquee-mask" data-testid="client-marquee">
      <div className="flex w-max items-center gap-16 animate-marquee" style={{ animationDuration: speed }}>
        {items.map((c, i) =>
          c.logo ? (
            <img
              key={`${c.name}-${i}`}
              src={c.logo}
              alt={c.name}
              className="h-12 sm:h-14 w-auto object-contain grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-300"
            />
          ) : (
            <span
              key={`${c.name}-${i}`}
              className={`whitespace-nowrap text-2xl sm:text-3xl text-slate-400 hover:text-[#0A1F44] transition-colors duration-300 ${c.style}`}
            >
              {c.name}
            </span>
          )
        )}
      </div>
    </div>
  );
};
